

export const index = 41;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/view/pdf-demo/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/41.CAG5_cGP.js","_app/immutable/chunks/Bzak7iHL.js","_app/immutable/chunks/69_IOA4Y.js","_app/immutable/chunks/DIeogL5L.js"];
export const stylesheets = [];
export const fonts = [];
